import cx from 'classnames';
import type { BlockViewProps } from '@plone/types';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/Banner/styles.module.css';
import Banner from '@redturtle/qubicaamf-theme/components/Blocks/Banner/Banner';
import type { ImageBannerData } from '@redturtle/qubicaamf-theme/components/Blocks/Banner/schema';

type BannerViewProps = Omit<BlockViewProps, 'data'> & {
  data: ImageBannerData;
};

const View = (props: BannerViewProps) => {
  const { className, data } = props;

  return (
    <section className={cx('block-banner', className)}>
      <div className={styles.bannerContainer}>
        <Banner data={data} />
      </div>
    </section>
  );
};

export default View;
